
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec0ad"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec0ad"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $25783e154135b584$exports = {};
$parcel$extendImportMap({
    "gJBV1": "_static_0.1c1c2c2e.mp4",
    "fdFVa": "_static_1.85b0b4e8.mp4",
    "5DtpZ": "_static_2.5d6d6ebf.mp4",
    "8nFnp": "_static_3.acce472b.mp4"
});


var $8a4c84356bd14ed2$exports = {};
$8a4c84356bd14ed2$exports = $parcel$resolve("gJBV1");


var $8f1f89da6ba20f3a$exports = {};
$8f1f89da6ba20f3a$exports = $parcel$resolve("fdFVa");


var $c98d2ff032526853$exports = {};
$c98d2ff032526853$exports = $parcel$resolve("5DtpZ");


var $1d249cbb4a5e8b4d$exports = {};
$1d249cbb4a5e8b4d$exports = $parcel$resolve("8nFnp");


const $2b6e161c9edcf319$var$videos = [
    (0, (/*@__PURE__*/$parcel$interopDefault($8a4c84356bd14ed2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8f1f89da6ba20f3a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c98d2ff032526853$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1d249cbb4a5e8b4d$exports)))
];
// Wait for DOM to be ready
document.addEventListener("DOMContentLoaded", ()=>{
    const videoSource = document.getElementById("video-source");
    const videoElement = videoSource.parentElement;
    // Set random video source
    videoSource.src = $2b6e161c9edcf319$var$videos[Math.floor(Math.random() * $2b6e161c9edcf319$var$videos.length)];
    // Reload the video element to apply the new source
    videoElement.load();
});


//# sourceMappingURL=repo.c241e465.js.map
